//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { cardPropertyDocuments } from './CardPropertyDocuments.js'
import { cardPropertyMixin } from './CardPropertyMixin.js'
import FilesField from '../File/FilesField.vue'

export default {
  name: 'CardPropertyDocuments',
  components: {
    FilesField
  },
  mixins: [cardPropertyDocuments, cardPropertyMixin],
  data: function () {
    return {
      expandedLocal: !!this.tabProp.componentProps.expanded
    }
  },
  computed: {
    selectModeEdit: function () {
      return !!this.tabProp.componentProps.filesFieldType
    },
    label: function () {
      const filesCount = this.category ? this.category.files.length : 0
      return this.tabProp.name.toUpperCase() + ' ( ' + filesCount + ' )'
    },
    rule: function () {
      if (this.category && !this.category.hasFiles()) {
        return !this.tabProp.required
      }
      return true
    }
  },
  methods: {
    onFileAddToUpload: function (fileWrapper) {
      const handler = this.tabProp.componentProps.handlers && this.tabProp.componentProps.handlers.add || null
      if (handler) {
        handler(fileWrapper)
      }
    },
    onFileRemoveFromUpload: function (fileWrapper) {
      const handler = this.tabProp.componentProps.handlers && this.tabProp.componentProps.handlers['remove-from-upload'] || null
      if (handler) {
        handler(fileWrapper)
      }
    },
    onFileRemove: function ({ file: fileWrapper, filesGroup }) {
      filesGroup.removeFile(fileWrapper)
    },
    onExpansionChange: function (value) {
      this.tabProp.componentProps.expanded = value
    }
  }
}
